export default __webpack_public_path__ + "static/media/330_dummy2016-meditation01-de.a3392fb2.png";